<label>
    <input class='toggle-checkbox' type='checkbox' [checked]="darkMode" (change)="onToggle()" />
    <div class='toggle-slot'>
        <div class='sun-icon-wrapper'>
            <svg class="sun-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 456.54 456.54" xml:space="preserve">
                <g>
                    <rect x="215.27" y="379.3" width="26" height="77.24" />
                    <rect x="215.27" width="26" height="77.24" />
                    <rect x="81.169" y="323.75" transform="matrix(-0.7071 -0.7071 0.7071 -0.7071 -95.4776 685.1913)"
                        width="26" height="77.239" />
                    <rect x="349.372" y="55.544" transform="matrix(-0.7071 -0.7071 0.7071 -0.7071 552.0227 416.9835)"
                        width="26" height="77.239" />
                    <rect y="215.27" width="77.24" height="26" />
                    <rect x="379.3" y="215.27" width="77.24" height="26" />
                    <rect x="81.169" y="55.548" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -39.005 94.1686)"
                        width="26" height="77.239" />
                    <rect x="349.378" y="323.753" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -150.0985 362.3763)"
                        width="26" height="77.239" />
                    <circle cx="228.267" cy="228.271" r="124.003" />
                    <circle cx="228.267" cy="228.271" r="95.142" />
                </g>
            </svg>
        </div>
        <div class='toggle-circle-button'></div>
        <div class='moon-icon-wrapper'>
            <svg class="moon-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
                xmlns:xlink="http://www.w3.org/1999/xlink">
                <g>
                    <path
                        d="m275.4,500.7c-135,0-244.7-109.8-244.7-244.7 1.06581e-14-134.9 109.8-244.7 244.7-244.7 8.2,0 16.4,0.4 24.6,1.2 7.2,0.7 13.5,5.2 16.5,11.7s2.4,14.2-1.6,20.2c-23,33.8-35.2,73.3-35.2,114.2 0,105 78.7,192.2 183.2,202.6 7.2,0.7 13.5,5.2 16.5,11.7 3.1,6.5 2.4,14.2-1.6,20.2-45.8,67.4-121.4,107.6-202.4,107.6zm-12.5-448c-106.5,6.5-191.2,95.2-191.2,203.3 1.42109e-14,112.3 91.4,203.7 203.7,203.7 56.4,0 109.6-23.4 147.8-63.7-46.2-11.7-88.1-36.8-120.8-72.6-41.1-45.2-63.8-103.6-63.8-164.6 0.1-37.1 8.4-73.2 24.3-106.1z" />
                </g>
            </svg>
        </div>
    </div>
</label>